// extracted by mini-css-extract-plugin
module.exports = {"vscroll":"VirtualScroll_vscroll_Tgqa5","block":"VirtualScroll_block_2m6o9"};